import { RouteConfig } from 'vue-router'

const LayoutEmpty = () => import('@/views/LayoutEmpty.vue')

const Landing = () => import('@/views/sportsfestival-2022/Landing.vue')

export const landingRoute: RouteConfig = {
  path: 'landing',
  name: 'landing',
  component: Landing,
  meta: {
    title: '2022体育节',
    showMenu: false,
  },
}

export default [
  {
    path: '/sports-festival-2022',
    name: 'sports_festival_2022',
    component: LayoutEmpty,
    children: [landingRoute],
  },
]
